import { render, staticRenderFns } from "./Agile.vue?vue&type=template&id=3c4e8c61"
import script from "./Agile.vue?vue&type=script&lang=js"
export * from "./Agile.vue?vue&type=script&lang=js"
import style0 from "./Agile.vue?vue&type=style&index=0&id=3c4e8c61&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4e8c61')) {
      api.createRecord('3c4e8c61', component.options)
    } else {
      api.reload('3c4e8c61', component.options)
    }
    module.hot.accept("./Agile.vue?vue&type=template&id=3c4e8c61", function () {
      api.rerender('3c4e8c61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Agile.vue"
export default component.exports